export const tokenManager = {
  getToken: () => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');

    if (tokenFromUrl) {
      return tokenFromUrl;
    }

    return undefined;
  },
};
